import './styles.index.js';
global.Quill = require('quill');
global.QuillDeltaToHtmlConverter = require('quill-delta-to-html').QuillDeltaToHtmlConverter;

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('Root/views', true, /\.js$/));


